import { Box, BoxProps, Tooltip } from '@mui/material';
import { ReactNode } from 'react';

import { Timestamp } from '@/components/data/Timestamp';
import { useTimelineNavigationContext } from '@/context/TimelineNavigationContext';

export type SelectableTimestampBoxProps = {
    timestamp: string;
    children: ReactNode;
    subsample?: boolean;
    includeSeconds?: boolean;
} & BoxProps;

export const SelectableTimestampBox = ({
    timestamp,
    children,
    subsample,
    includeSeconds,
    sx,
    ...props
}: SelectableTimestampBoxProps) => {
    const { setSelectedTimestamp, setSelectedSubsampleTimestamp } = useTimelineNavigationContext();
    const setTimestamp = subsample ? setSelectedSubsampleTimestamp : setSelectedTimestamp;

    return (
        <Tooltip
            followCursor={true}
            placement="right-start"
            title={<Timestamp value={timestamp} sx={{ fontSize: '12px' }} includeSeconds={includeSeconds} />}
            onClick={() => setTimestamp(timestamp)}
        >
            <Box sx={{ cursor: 'pointer', ...sx }} {...props}>
                {children}
            </Box>
        </Tooltip>
    );
};
